import React from 'react';

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800 py-12">
      <div className="max-w-5xl mx-auto px-4">
        <header className="mb-12">
          <h1 className="text-4xl font-display font-bold text-primary-900 dark:text-primary-300 mb-4">Mentions légales</h1>
          <p className="text-gray-600 dark:text-gray-400 max-w-2xl">Ces mentions sont fournies conformément aux obligations légales applicables aux plateformes en ligne opérant depuis le Sénégal.</p>
        </header>

        <div className="space-y-10">
          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Éditeur du site</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              Village Artisanal Sénégal ("la Plateforme") – Structure de valorisation de l'artisanat traditionnel. <br />
              Siège social : Dakar, Sénégal. <br />
              Email : <a href="mailto:contact@villageartisanal.sn" className="text-accent-600 dark:text-accent-400 hover:underline">contact@villageartisanal.sn</a> <br />
              Téléphone : +221 77 931 78 65
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Responsable de publication</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">Le responsable de publication est le représentant légal de la Plateforme.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Hébergement</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              Le site est hébergé sur une infrastructure cloud sécurisée. <br />
              Localisation des serveurs : Europe / Afrique (selon optimisation). <br />
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Propriété intellectuelle</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              L'intégralité des éléments (textes, logos, identités graphiques, illustrations, fiches produits, photographies) présents sur la Plateforme sont protégés par les lois sur la propriété intellectuelle. Toute reproduction ou réutilisation non autorisée est interdite sans accord préalable écrit.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Contenu des artisans</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              Les artisans restent propriétaires des visuels, descriptions et contenus qu'ils publient. Ils garantissent disposer des droits nécessaires et que les contenus ne portent pas atteinte aux droits de tiers ni aux lois en vigueur.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Limitation de responsabilité</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              La Plateforme agit comme intermédiaire facilitateur entre artisans et acheteurs. Elle ne peut être tenue responsable des litiges liés à la qualité, conformité ou livraison des produits, sauf dispositions légales contraires.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary-800 dark:text-primary-400 mb-3">Signalement</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              Pour toute notification relative à un contenu illicite ou abusif, contactez-nous à l'adresse : <a href="mailto:signalement@villageartisanal.sn" className="text-accent-600 dark:text-accent-400 hover:underline">signalement@villageartisanal.sn</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold dark:text-primary-300 text-primary-800 mb-3">Mise à jour</h2>
            <p className="text-gray-700 dark:text-primary-300 leading-relaxed">Dernière mise à jour : {new Date().toLocaleDateString()} – Ces mentions peuvent évoluer pour refléter des changements réglementaires.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegales;
